module.exports = __webpack_public_path__ + "app-static/img/09.c84c84dd.png";